module.exports = __webpack_public_path__ + "img/brandon-martinez.9236cada.png";